import { render } from "./MakeUp.vue?vue&type=template&id=0f36711e&scoped=true"
import script from "./MakeUp.vue?vue&type=script&lang=js"
export * from "./MakeUp.vue?vue&type=script&lang=js"

import "./MakeUp.vue?vue&type=style&index=0&id=0f36711e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f36711e"]])

export default __exports__